module.exports = __webpack_public_path__ + "img/list.38252884.svg";